import { render, staticRenderFns } from "./ClientsRevenue.vue?vue&type=template&id=7bbfbbc0&scoped=true&"
import script from "./ClientsRevenue.vue?vue&type=script&lang=js&"
export * from "./ClientsRevenue.vue?vue&type=script&lang=js&"
import style0 from "./ClientsRevenue.vue?vue&type=style&index=0&id=7bbfbbc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbfbbc0",
  null
  
)

export default component.exports